import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { popup as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    options: {
      shouldShowCloseButton: true,
    },
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
